import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useCardSystemEnabled() {
  const { data: enabled = false, isLoading } = useQuery({
    queryKey: ["card-system-enabled"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("app_settings")
        .select("value")
        .eq("key", "card_system_enabled")
        .maybeSingle();

      if (error || !data) return false;
      return data.value === true || data.value === "true";
    },
    staleTime: 5 * 60 * 1000,
  });

  return { enabled, isLoading };
}
